import type { TCustomField } from '@src/shared/types/custom-field';
import { getCustomFieldColumnByType } from '../constants/column-types';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@src/design-system/tooltip';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';

export const CustomFieldItemIconTooltip = ({
  customField,
}: {
  customField: TCustomField;
}) => {
  const column = getCustomFieldColumnByType(customField.type);
  if (!column) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <column.icon className='size-6' />
      </TooltipTrigger>
      <TooltipContent>{formatTextForDisplay(customField.type)}</TooltipContent>
    </Tooltip>
  );
};
